import React from 'react'
import { Box, List, Typography } from '@mui/material'
import { StepListItem } from './StepListItem'
import patternRight from '../../../common/images/gridPatternRight.png'
import patternLeft from '../../../common/images/gridPatternLeft.png'

export function AllStepsView({ cards, onSelectStep, activeStepId, onOpenDrawer, onCompleteStep }) {
  const selectedStepDetails = cards.find(card => card.id === activeStepId)

  let wrapperSx = baseImagePreviewWrapperSx
  let imgStyle = { maxWidth: '300px', maxHeight: '300px', objectFit: 'contain' }

  if (selectedStepDetails && selectedStepDetails.id === 3) {
    wrapperSx = {
      ...baseImagePreviewWrapperSx,
      position: 'absolute',
      width: '50%',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: 'auto'
    }
    imgStyle = {
      width: '100%',
      maxHeight: '300px',
      objectFit: 'contain'
    }
  }

  return (
    <Box sx={allStepsContainerSx}>
      <Box flex={1} sx={{ maxHeight: '500px', overflowY: 'auto', pr: 1 }}>
        <List sx={{ py: 0 }}>
          {cards.map(card => (
            <StepListItem
              key={card.id}
              step={card}
              onSelectStep={onSelectStep}
              isActive={card.id === activeStepId}
              onOpenDrawer={onOpenDrawer}
              isDisabled={card.isDisabled}
              onCompleteStep={onCompleteStep}
            />
          ))}
        </List>
      </Box>

      <Box sx={rightPreviewPaneSx}>
        <Box component='img' alt='pattern-left' src={patternLeft} sx={imagePatternSx('bottomLeft')} />
        <Box component='img' alt='pattern-right' src={patternRight} sx={imagePatternSx('topRight')} />

        {selectedStepDetails && selectedStepDetails.previewImage ? (
          <Box sx={wrapperSx}>
            <img src={selectedStepDetails.previewImage} alt={selectedStepDetails.title} style={imgStyle} />
          </Box>
        ) : (
          <Box sx={wrapperSx}>
            <Typography variant='subtitle1' color='textSecondary'>
              {selectedStepDetails ? 'Image not available' : 'Select a step to see preview'}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const allStepsContainerSx = {
  display: 'flex',
  borderRadius: '20px',
  width: '100%',
  padding: 4,
  background: ' #FFFFFF',
  border: '2px solid #DBDBE6',
  minWidth: '900px',
  maxWidth: '1276px'
}

const rightPreviewPaneSx = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 2,
  borderLeft: '1px solid #DDDDDD',
  minHeight: '400px',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#fff'
}

const imagePatternSx = position => ({
  position: 'absolute',
  width: '300px',
  height: 'auto',
  zIndex: 0,
  ...(position === 'topRight' && { top: -20, right: 0 }),
  ...(position === 'bottomLeft' && { bottom: -20, left: -30 })
})

const baseImagePreviewWrapperSx = {
  zIndex: 1,
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 2
}
